import { Plugins, Context } from '@leverege/plugin';
import MoltenUtil from "../../MoltenUtil.js";
export default class BlockerHookRunner {
  constructor(options) {
    this.isCancelled = false;
    this.options = options;
  }

  /**
   * Cancels the hooks
   */
  cancel() {
    this.isCancelled = true;
  }
  async run() {
    const {
      hooks,
      matchContext,
      context
    } = this.options;

    // Get all plugins
    const plgs = [...Plugins.get('BlockerHook', p => Context.isMatch(matchContext, p)), ...(hooks || [])].sort(MoltenUtil.numSortComparator);
    if (plgs.length === 0) {
      return {
        done: true
      }; // no blocking to be done
    }

    // Run all hooks with same sort value in parallel
    let cSort = plgs[0].sort || 0;
    const run = [[]];
    let curr = run[0];
    for (let n = 0; n < plgs.length; n++) {
      const plg = plgs[n];
      const sort = plg.sort || 0;
      if (sort !== cSort) {
        // make a new group
        curr = [];
        cSort = sort;
        run.push(curr);
      }
      curr.push(plg);
    }
    for (let n = 0; n < run.length; n++) {
      // run current list
      const ex = run[n].map(p => p.execute(context));
      // eslint-disable-next-line no-await-in-loop
      this.shutdownHooks = await Promise.all(ex);

      // If we are cancelled, just stop
      if (this.isCancelled === true) {
        return {
          cancelled: true
        };
      }
    }
    return {
      done: true
    };
  }
  async shutdown() {
    const {
      context
    } = this.options;
    const sh = this.shutdownHooks;
    if (sh && sh.length > 0) {
      for (let n = 0; n < sh.length; n++) {
        try {
          if (typeof sh[n] === 'function') {
            sh[n](context);
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }
    }
  }
}